import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/heart': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M458.4 64.3c75.3 63.4 64.1 166.6 10.6 221.3l-175.4 178.7c-10 10.2-23.3 15.8-37.6 15.8-14.2 0-27.6-5.7-37.6-15.9l-175.4-178.7c-53.6-54.7-64.6-157.9 10.6-221.2 57.8-48.7 147.1-41.3 202.4 15 55.3-56.3 144.6-63.6 202.4-15zM434.8 251.8c36.2-36.9 43.8-107.7-7.3-150.8-38.7-32.6-98.7-27.9-136.5 10.6l-35 35.7-35-35.7c-37.6-38.3-97.6-43.2-136.5-10.5-51.2 43.1-43.8 113.5-7.3 150.7l175.4 178.7c2.4 2.4 4.4 2.4 6.8 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/heart.js
// module id = 1774
// module chunks = 0